import httpFactory, { HttpType } from "@/api/httpFactory";
const maxBufferedEvents = 200;
const maxEventsPerRequest = 50;
const flushDelay = 1000;
const sessionId = Date.now().toString(36) +
    Math.random()
        .toString(36)
        .slice(2, 8);
let seq = 0;
let buffer = [];
let flushTimer;
let isFlushing = false;
export async function flushUiEvents() {
    if (flushTimer !== undefined) {
        window.clearTimeout(flushTimer);
        flushTimer = undefined;
    }
    if (isFlushing || buffer.length === 0)
        return;
    // The server only accepts events from a signed-in user: drop the ones logged before signing in
    /*
    if (!(sessionStorage.getItem("token") || localStorage.getItem("token"))) {
      buffer = [];
      return;
    }
    */
    isFlushing = true;
    const events = buffer.splice(0, maxEventsPerRequest);
    try {
        const http = httpFactory.getHttp(HttpType.Api);
        await http.post("client-logs", { sessionId, events });
    }
    catch {
        // Diagnostics must never break the UI: the events are dropped
    }
    finally {
        isFlushing = false;
        if (buffer.length > 0 && flushTimer === undefined)
            flushTimer = window.setTimeout(flushUiEvents, flushDelay);
    }
}
export function logUiEvent(type, data) {
    buffer.push({ seq: ++seq, timestamp: new Date().toISOString(), type, data });
    // Keep the most recent events when the server cannot be reached
    if (buffer.length > maxBufferedEvents)
        buffer = buffer.slice(buffer.length - maxBufferedEvents);
    if (flushTimer === undefined)
        flushTimer = window.setTimeout(flushUiEvents, flushDelay);
}
export function getUiLogHeaders() {
    return {
        "X-Client-Session": sessionId,
        "X-Client-Seq": seq.toString()
    };
}
function formatDate(value) {
    return value instanceof Date ? value.toISOString() : value;
}
/**
 * Keeps only the identifiers, times and recurrence fields of a scheduler record (no notes or customer data).
 */
export function summarizeAppointment(record) {
    if (record == null)
        return null;
    return {
        Id: record.Id,
        RecurrenceID: record.RecurrenceID,
        ParentId: record.ParentId,
        ChildId: record.ChildId,
        StartTime: formatDate(record.StartTime),
        EndTime: formatDate(record.EndTime),
        EmployeeId: record.EmployeeId,
        RecurrenceRule: record.RecurrenceRule,
        RecurrenceRuleOverride: record.RecurrenceRuleOverride,
        RecurrenceException: record.RecurrenceException
    };
}
